import store from '@/vuex/store'
export default {
  inserted(el, bindling) {
    // bindling.value为指令的绑定值
    let perVal = bindling.value
    if (bindling.value) {
      let pers = store.getters.userInfo.auth_list
      // 这个权限信息(即pers)应该是不同用户登录时从后台拿到的对应的信息
      let hasPer = pers.some((item) => {
        return perVal.includes(item)
      })
      // 没有权限就先隐藏此元素吧
      if (!hasPer) {
        el.style.display = 'none'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/directives/permission.js